// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"ProductImage_imageContainer__0QhhQ","image":"ProductImage_image__Ft8cJ"};